import type { OrderListSortBy, OrderRow, OrderStats, OrderStatus } from '../types';

export const EMPTY_ORDER_STATS: OrderStats = {
  totalOrders: 0,
  totalDeltaPercent: 0,
  totalComparisonLabel: '',
  pendingFulfillment: 0,
  outForDelivery: 0,
  delayed: 0,
  delayedDelta: 0,
};

/** @deprecated Mock snapshot — prefer `fetchOrderSummary` for live cards. */
export const ORDER_STATS: OrderStats = {
  totalOrders: 12485,
  totalDeltaPercent: 5.4,
  totalComparisonLabel: 'vs previous period',
  pendingFulfillment: 342,
  outForDelivery: 891,
  delayed: 24,
  delayedDelta: 2,
};

export const ORDER_ROWS: OrderRow[] = [
  {
    id: 'BYQ-10482',
    orderNumber: 'BYQ-10482',
    customerName: 'Aarav Mehta',
    status: 'CONFIRMED',
    totalItems: 8,
    totalPaise: 185900,
    originId: 'wh-mumbai-central',
    originName: 'Mumbai Central',
  },
  {
    id: 'BYQ-10481',
    orderNumber: 'BYQ-10481',
    customerName: 'Priya Nair',
    status: 'DISPATCHED',
    totalItems: 5,
    totalPaise: 124500,
    originId: 'wh-bandra-west',
    originName: 'Bandra West',
  },
  {
    id: 'BYQ-10480',
    orderNumber: 'BYQ-10480',
    customerName: 'Kabir Sethi',
    status: 'PICKING',
    totalItems: 11,
    totalPaise: 249900,
    originId: 'wh-andheri-east',
    originName: 'Andheri East',
  },
  {
    id: 'BYQ-10479',
    orderNumber: 'BYQ-10479',
    customerName: 'Ananya Rao',
    status: 'PACKED',
    totalItems: 3,
    totalPaise: 69900,
    originId: 'wh-mumbai-central',
    originName: 'Mumbai Central',
  },
  {
    id: 'BYQ-10478',
    orderNumber: 'BYQ-10478',
    customerName: 'Rohan Shah',
    status: 'DELIVERED',
    totalItems: 6,
    totalPaise: 151000,
    originId: 'wh-thane-west',
    originName: 'Thane West',
  },
  {
    id: 'BYQ-10477',
    orderNumber: 'BYQ-10477',
    customerName: 'Meera Iyer',
    status: 'CONFIRMED',
    totalItems: 4,
    totalPaise: 93500,
    originId: 'wh-bandra-west',
    originName: 'Bandra West',
  },
  {
    id: 'BYQ-10476',
    orderNumber: 'BYQ-10476',
    customerName: 'Dev Malhotra',
    status: 'DISPATCHED',
    totalItems: 9,
    totalPaise: 203400,
    originId: 'wh-andheri-east',
    originName: 'Andheri East',
  },
  {
    id: 'BYQ-10475',
    orderNumber: 'BYQ-10475',
    customerName: 'Sara Khan',
    status: 'CANCELLED',
    totalItems: 2,
    totalPaise: 41000,
    originId: 'wh-thane-west',
    originName: 'Thane West',
  },
];

export function filterOrdersByOrigin(rows: OrderRow[], originId: string): OrderRow[] {
  if (originId === 'all') return rows;
  return rows.filter((row) => row.originId === originId);
}

export function filterOrdersByStatus(rows: OrderRow[], status: 'all' | OrderStatus): OrderRow[] {
  if (status === 'all') return rows;
  return rows.filter((row) => row.status === status);
}

export function searchOrders(rows: OrderRow[], query: string): OrderRow[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return rows;

  return rows.filter((row) =>
    [row.id, row.orderNumber, row.customerName, row.originName, row.status].some((value) =>
      value.toLowerCase().includes(normalizedQuery),
    ),
  );
}

export function sortOrders(rows: OrderRow[], sortBy: OrderListSortBy): OrderRow[] {
  const nextRows = [...rows];

  if (sortBy === 'orderNumber') {
    return nextRows.sort((a, b) => a.orderNumber.localeCompare(b.orderNumber, 'en-IN'));
  }

  return nextRows;
}

export function paginateOrders(rows: OrderRow[], pageIndex: number, pageSize: number): OrderRow[] {
  const start = pageIndex * pageSize;
  return rows.slice(start, start + pageSize);
}
